import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('./Welcome.vue')
  },
  {
    path: '/anispark-debug',
    name: 'AniSparkDebug',
    component: () => import('./App.vue')
  },
  {
    path: '/anispark-debug-volc',
    name: 'AniSparkDebugVolc',
    component: () => import('./App.vue')
  },
  {
    path: '/botim-preview',
    name: 'BotimPreview',
    component: () => import('./BotimPreview.vue')
  },
  {
    path: '/botim-preview-volc',
    name: 'BotimPreviewVolc',
    component: () => import('./BotimPreview.vue')
  },
  {
    path: '/botimai-blob-preview',
    name: 'BotimAIBlobPreview',
    component: () => import('./BotimAIBlobPreview.vue')
  },
  {
    path: '/3d-preview',
    name: 'ThreeDPreview',
    component: () => import('./ThreeDPreview.vue')
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router; 